/*
 Auto-generated by generate-java-to-ts-maven-plugin. Do not edit.
 Source: de.mhus.vance.api.insights.ModelCatalogLayer
*/
export var ModelCatalogLayer;
(function (ModelCatalogLayer) {
    ModelCatalogLayer["BUNDLED"] = "BUNDLED";
    ModelCatalogLayer["SYSTEM_AUTO"] = "SYSTEM_AUTO";
    ModelCatalogLayer["SYSTEM"] = "SYSTEM";
    ModelCatalogLayer["TENANT_AUTO"] = "TENANT_AUTO";
    ModelCatalogLayer["TENANT"] = "TENANT";
    ModelCatalogLayer["PROJECT_AUTO"] = "PROJECT_AUTO";
    ModelCatalogLayer["PROJECT"] = "PROJECT";
})(ModelCatalogLayer || (ModelCatalogLayer = {}));
//# sourceMappingURL=ModelCatalogLayer.js.map